import * as React from "react";
import { Path, Rect, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const CAIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="CA" {...props}>
    <Rect width="16" height="12" fill="#F5F5F5" />
    <G>
      <Rect
        id="Rectangle 1230"
        x="-96"
        y="-133"
        width="960"
        height="530"
        fill="white"
      />
    </G>
    <G id="Local / Flag / Canada">
      <G clip-path="url(#clip0_5428_6736)">
        <Rect width="16" height="12" rx="1" fill="white" />
        <G id="flag">
          <G id="contents">
            <Path
              id="middle"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4 0H12.5V12H4V0Z"
              fill="#F7FCFF"
            />
            <Path
              id="Combined Shape"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.16447 4.20127L7.98652 3L8 10H7.65742L7.86761 8.2677C7.86761 8.2677 5.56179 8.69124 5.75241 8.4776C5.94304 8.26397 6.05283 7.87204 6.05283 7.87204L4 6.47393C4 6.47393 4.32382 6.46978 4.58726 6.30984C4.8507 6.1499 4.32382 5.20134 4.32382 5.20134L5.36027 5.35527L5.75241 4.92023L6.53439 5.7557H6.8859L6.53439 3.842L7.16447 4.20127ZM8 10V3L8.83553 4.20127L9.46561 3.842L9.1141 5.7557H9.46561L10.2476 4.92023L10.6397 5.35527L11.6762 5.20134C11.6762 5.20134 11.1493 6.1499 11.4127 6.30984C11.6762 6.46978 12 6.47393 12 6.47393L9.94717 7.87204C9.94717 7.87204 10.057 8.26397 10.2476 8.4776C10.4382 8.69124 8.13239 8.2677 8.13239 8.2677L8.34258 10H8Z"
              fill="#E31D1C"
            />
            <Path
              id="right"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 0H16V12H12V0Z"
              fill="#E31D1C"
            />
            <Path
              id="left"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0H4V12H0V0Z"
              fill="#E31D1C"
            />
          </G>
        </G>
      </G>
    </G>
    <Defs>
      <ClipPath id="clip0_5428_6736">
        <Rect width="16" height="12" rx="1" fill="white" />
      </ClipPath>
    </Defs>
  </Icon>
);
